import { render, staticRenderFns } from "./accountingGivenConfig.vue?vue&type=template&id=ad3dcc20&"
import script from "./accountingGivenConfig.vue?vue&type=script&lang=js&"
export * from "./accountingGivenConfig.vue?vue&type=script&lang=js&"
import style0 from "./accountingGivenConfig.vue?vue&type=style&index=0&id=ad3dcc20&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports